import posterTemplate from './posterLayoutTmpl';

export default function buildPosterProduct(network, password, qrCodeSvgStr) {
    return posterTemplate(network, password, qrCodeSvgStr);
}